



















import Vue from "vue";
import data from "@/data/userData";
import User from "@/models/User";

export default Vue.extend({
  components: {},

  created() {
    const initialData = data;
    User.insert({ data: initialData });
  },

  computed: {
    users(): User[] {
      return User.query().with("todos").orderBy("id", "desc").get();
    },
  },

  methods: {
    update(user: User, name: string): void {
      user.$update({ name });
    },

    destroy(user: User): void {
      user.$delete();
    },

    resetScrollToContainerTop(): void {
      const container: HTMLElement | null =
        document?.querySelector(".container");
      if (container) {
        container.scrollTop = 0;
      }
    },
  },

  mounted() {
    this.resetScrollToContainerTop();
  },
});
